// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"20ccedd6","254":"4b863e8f","277":"6f14f84a","412":"234decd5","514":"bfc7fac5","594":"8945cedc","622":"ef666abb","658":"6d98c2fd","730":"9a2c0d56","760":"f3b56804","989":"42fb380d"}[chunkId] + ".chunk.js";
};